(() => {
  if (window.lenniesScheduledDispatch) { window.lenniesScheduledDispatch(); return; }
  const ukDay = new Intl.DateTimeFormat('en-CA', {timeZone:'Europe/London',year:'numeric',month:'2-digit',day:'2-digit'});
  const label = new Intl.DateTimeFormat('en-GB', {timeZone:'UTC',weekday:'long',day:'numeric',month:'long',year:'numeric'});
  function update() {
    const parts=Object.fromEntries(ukDay.formatToParts(new Date()).map(p=>[p.type,p.value]));
    const today=`${parts.year}-${parts.month}-${parts.day}`;
    document.querySelectorAll('[data-lennies-ships]').forEach(box=>{
      let tags=[];try{tags=JSON.parse(box.dataset.shipsTags||'[]');}catch{}
      const dates=(Array.isArray(tags)?tags:[]).flatMap(tag=>{
        const match=String(tag).trim().match(/^ships\(\s*(\d{1,2})\/(\d{1,2})\/(\d{4})\s*\)$/i);
        if(!match)return [];
        const day=`${match[3]}-${match[2].padStart(2,'0')}-${match[1].padStart(2,'0')}`,date=new Date(day+'T00:00:00Z');
        return Number.isFinite(date.getTime())&&date.toISOString().slice(0,10)===day&&day>=today?[day]:[];
      }).sort();
      const day=dates.at(-1)||'';
      const product=box.closest('product-info');
      if(product)product.toggleAttribute('data-lennies-scheduled-active',Boolean(day));
      if(box.dataset.displayedShipsDate===day)return;
      box.dataset.displayedShipsDate=day;box.hidden=!day;box.replaceChildren();
      if(!day)return;
      const heading=document.createElement('strong');heading.textContent='Estimated dispatch: '+label.format(new Date(day+'T00:00:00Z')).replace(',','');
      const text=document.createElement('p');text.style.margin='6px 0 0';text.textContent='After dispatch, delivery follows the estimated timescale of the service you choose. Courier delays can sometimes occur.';
      const mixed=document.createElement('p');mixed.style.margin='6px 0 0';mixed.textContent='If another item in your basket has a later dispatch date, your whole order will be sent together using the later dispatch estimate.';
      box.append(heading,mixed,text);
    });
  }
  window.lenniesScheduledDispatch=update;
  update();document.addEventListener('shopify:section:load',update);
  let queued=false;
  const scope=document.querySelector('main')||document.body;
  new MutationObserver(mutations=>{
    const relevant=mutations.some(mutation=>[...mutation.addedNodes].some(node=>
      node.nodeType===1&&(node.matches?.('[data-lennies-ships]')||node.querySelector?.('[data-lennies-ships]'))
    ));
    if(relevant&&!queued){queued=true;queueMicrotask(()=>{queued=false;update();});}
  }).observe(scope,{childList:true,subtree:true});
  setInterval(update,60000);
})();
